import { Party } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplacePartyAction, deletePartiesAction, deletePartyAction, setPartiesAction } from '../reducers/partyReducer';

export const usePartyActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceParty = (party: Party) => {
        dispatch(addOrReplacePartyAction(party));
    }

    const setParties = (parties: Party[]) => {
        dispatch(setPartiesAction(parties));
    }

    const deleteParty = (partyId: string) => {
        dispatch(deletePartyAction(partyId));
    }

    const deleteParties = (partyIds: string[]) => {
        dispatch(deletePartiesAction(partyIds));
    }

    return { addOrReplaceParty, setParties, deleteParty, deleteParties };
}
